import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Button } from 'reactstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import {
  logOut
} from '../../actions/appealActions'
import PropTypes from 'prop-types'
import { FaSignOutAlt, FaCommentAlt } from 'react-icons/fa'

class Header extends Component {
  render () {
    return (
      <div className='header'>
        <Container>
          <Row>
            <Col xs='12' sm='6'>
              <h1>
                <Link to='/' >Appeal Parking Charge</Link>
              </h1>
            </Col>
            <Col xs='12' sm='6'>
              {
                this.props.appeal.data.pcn
                  ? <div className='loggedInArea'>
                    <p>PCN: {this.props.appeal.data.pcn}</p>
                    <p>Email: {this.props.appeal.data.email}</p>
                    {this.props.appeal.data.replies
                      ? this.props.location.pathname.includes('/messages')
                        ? <Link to={`/appeal/${this.props.appeal.data.appealID}`} className='btn btn-primary mr-2'>Appeal Details</Link>
                        : <Link to={`/appeal/${this.props.appeal.data.appealID}/messages`} className='btn btn-primary mr-2'><FaCommentAlt /> Messages</Link>
                      : null }
                    <Button color='secondary' onClick={() => this.props.logOut()}><FaSignOutAlt />Log out</Button>
                  </div>
                  : null
              }
            </Col>
          </Row>
        </Container>
      </div>

    )
  }
}

Header.propTypes = {
  logOut: PropTypes.func,
  appeal: PropTypes.object,
  location: PropTypes.object
}

Header.defaultProps = {
  appeal: null
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      // changePage: () => push('/about-us'),
      logOut
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header))



// WEBPACK FOOTER //
// ./src/modules/Header/Header.jsx